import { z } from 'zod';
import { defineEndpoint } from '../define';

export const GitRefSchema = z.object({
  name: z.string(),
  sha: z.string(),
  /** Tip commit of the ref; null when the lookup failed. */
  latestCommit: z.object({ message: z.string(), date: z.string() }).nullable(),
});
export type GitRef = z.infer<typeof GitRefSchema>;

/** Top 10 branches, filtered by `q` substring when given. */
export const listGitBranches = defineEndpoint({
  method: 'GET',
  path: '/v1/release-products/:productId/git/branches',
  params: z.object({ productId: z.string().uuid() }),
  query: z.object({ q: z.string().optional() }),
  body: z.undefined(),
  response: z.object({ data: z.array(GitRefSchema) }),
});
